var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { AutocompleteInput, ReferenceInput } from "react-admin";
import { useAliasRenderer } from "@/hooks/useAliasRenderer";
var SelectElection = function (_a) {
    var tenantId = _a.tenantId, electionEventId = _a.electionEventId, source = _a.source, label = _a.label, onSelectElection = _a.onSelectElection, customStyle = _a.customStyle, isRequired = _a.isRequired, disabled = _a.disabled, value = _a.value;
    isRequired = isRequired === undefined ? true : isRequired;
    var aliasRenderer = useAliasRenderer();
    var electionFilterToQuery = function (searchText) {
        if (!searchText || searchText.length === 0) {
            return { name: "" };
        }
        return { "name@_ilike,alias@_ilike": searchText.trim() };
    };
    return (_jsx(ReferenceInput, __assign({ fullWidth: true, reference: "sequent_backend_election", source: source, filter: {
            tenant_id: tenantId,
            election_event_id: electionEventId,
        }, perPage: 200, enableGetChoices: function (_a) {
            var q = _a.q;
            return q && q.length >= 3;
        }, label: label, disabled: disabled, required: isRequired, value: value, defaultValue: value, sort: { field: "alias", order: "ASC" } }, { children: _jsx(AutocompleteInput, { TextFieldProps: { required: isRequired }, label: label, fullWidth: true, optionText: aliasRenderer, filterToQuery: electionFilterToQuery, onChange: onSelectElection, debounce: 300, sx: customStyle, disabled: disabled }) })));
};
export default SelectElection;
